import React, { useEffect, useState } from 'react';
import { Container, Row, Spinner, Alert, Col, Table, Form, Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { getSubscribers } from '../../../slices/thunk';
import { Link } from 'react-router-dom';

const AdminSubscriberData = () => {
  document.title = 'Subscribers Data';
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState({ show: false, variant: '', message: '' }); // Notification state

  const subscirbersData = useSelector((state: any) => state.Admin.subscribersData);
  
  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatch(getSubscribers())
  },[])

  return (
    <React.Fragment>
      
      <div className="page-content">
        {notification.show && (
        <Alert variant={notification.variant} onClose={() => setNotification({ show: false, variant: '', message: '' })} dismissible>
          {notification.message}
        </Alert>
      )}
        <Container fluid>
          <Row>
           <Col xl={12}>
    <div className="table-responsive mt-4 mt-xl-0">
        <Table className="table-hover table-striped align-middle table-nowrap mb-0">
                  <thead>
                    
                <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Email</th>
                      <th scope="col">Active</th>
                      <th scope="col">Date</th>
                      
                      </tr>
                      
            </thead>
                  <tbody>
                  {subscirbersData.length && subscirbersData.map((item: any) => (
            
                <tr key={item.id}>
                        <td className="fw-medium">{ item.id}</td>
                    <td>{item.sub_email}</td>
                        <td>{ item.sub_email_active}</td>
                      <td>{item.sub_created_at}</td>
                      
                      </tr>
                    
                      ))}
              
            </tbody>
        </Table>
    </div>
</Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AdminSubscriberData;
